import React, { Component } from 'react';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import moment from 'moment';
const InspectionsTable = (props) => {
    let { classes,inspections } = props;
    inspections=inspections.sort((a,b)=>{
        return moment(a.vehicle.nextInspectionDue) -moment(b.vehicle.nextInspectionDue)
    })
    let today=new Date()
    return (
        <div className={classes.tableResponsiv}>
            <Table className={classes.table}>
                <TableHead className={classes[ "TableHeader"]}>
                    <TableRow>
                        <TableCell className={
                            classes.tableCell + " " + classes.tableHeadCell
                        }>Customer's ID</TableCell>
                        <TableCell className={
                            classes.tableCell + " " + classes.tableHeadCell
                        }>CallBit Unit ID</TableCell>
                        <TableCell className={
                            classes.tableCell + " " + classes.tableHeadCell
                        }>BIT Due Date</TableCell>
                    </TableRow>
                </TableHead>
                
                <TableBody>
                    {
                        inspections.map(vehicle=>{
                            let dateClasses = '';

                            if (new Date(vehicle.nextInspectionDue) < today) {
                                dateClasses = ''
                            } else if (new Date(vehicle.nextInspectionDue) > today && moment(vehicle.nextInspectionDue) < moment(today).add(7, 'days')) {
                                dateClasses = 'bg-red'
                            } else if (moment(vehicle.nextInspectionDue) > moment(today).add(7, 'days') && moment(vehicle.nextInspectionDue) < moment(today).add(15, 'days')) {
                                dateClasses = 'bg-yellow'
                            } else if (moment(vehicle.nextInspectionDue) > moment(today).add(15, 'days') && moment(vehicle.nextInspectionDue) < moment(today).add(30, 'days')) {
                                dateClasses = 'bg-lightgreen'
                            } else if (moment(vehicle.nextInspectionDue) > moment(today).add(30, 'days')) {
                                dateClasses = 'bg-lightgreen'
                            }
                            return <TableRow>
                                <TableCell>{ vehicle.vehicle.customerVehicleId}</TableCell>
                                <TableCell>{ vehicle.vehicle.id}</TableCell>
                                <TableCell className={dateClasses}>{vehicle.nextInspectionDue}</TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </div>
    );
}

export default InspectionsTable;


// WEBPACK FOOTER //
// ./src/components/Table/inspection-table.jsx